import styled from 'styled-components';
import { LARGE_VIEWPORT, SMALL_VIEWPORT, MOBILE_SMALL_VIEWPORT } from 'modules/theme/config';
import { BackTop, Modal } from 'antd/es';

export const CustomBackTop = styled(BackTop)`
  @media (max-width: ${SMALL_VIEWPORT}px) {
    bottom: 70px;
  }
`;

export const UserWaitlistWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const WaitlistModal = styled(Modal)`
  .ant-modal-close-x {
    width: 70px;
    height: 70px;
    line-height: 70px;
  }
  .ant-modal-body {
    padding: 24px;
  }
  .ant-modal-header {
    padding: 24px 24px 8px 24px;
    border-bottom: none;
    .ant-modal-title {
      text-align: center;
      font-size: 18px;
    }
  }
  .ant-divider {
    width: 40%;
    min-width: 40%;
    margin: 24px auto;
  }
  .ant-form,
  .ant-btn,
  .ant-picker-input > input {
    font-size: 14px;
  }
  .waitlist-unauthorized {
    text-align: center;
    a {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
  .waitlist-form-hint {
    color: ${({ theme }) => theme.colors.primary};
    text-align: center;
  }
  .waitlist-form-field {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
    margin-bottom: 24px;
    .waitlist-form-field-label {
      user-select: none;
    }
    .ant-form-item-explain-error {
      text-align: center;
      font-size: 13px;
    }
  }
  .waitlist-form-checkbox-buttons {
    display: flex;
    gap: 0 8px;
  }
  .waitlist-form-radio-buttons {
    display: flex;
    justify-content: center;
    gap: 0 8px;
    .ant-radio-button-wrapper {
      border-radius: 12px;
      padding: 0 16px;
      &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
        color: ${({ theme }) => theme.colors.white};
        background-color: ${({ theme }) => theme.colors.primary};
      }

      &:not(:first-child)::before {
        display: none;
      }
    }
  }
  .waitlist-form-checkbox-group {
    .ant-form-item-control-input-content {
      display: flex;
      justify-content: center;
    }
    .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      gap: 4px;
      .ant-checkbox + span {
        font-size: 14px;
      }
      .ant-checkbox-checked + span {
        color: #1890ff;
      }
    }
  }
  .waitlist-form-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .waitlist-form-buttons {
    display: flex;
    justify-content: end;
    margin-top: 48px;
  }
  .waitlist-form-summary {
    text-align: center;
  }
  .customStyle.react-tel-input .form-control {
    font-size: 14px;
    max-width: 180px;
  }
`;

export const UserWaitlistButton = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  right: 40px;
  bottom: 43px;
  z-index: 11;
  cursor: pointer;
  // background: rgb(225, 155, 255);
  // background: linear-gradient(90deg, rgba(225, 155, 255, 1) 0%, rgba(165, 215, 240, 1) 85%);
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 0 28px 28px 0;
  padding: 8px 20px 8px 36px;

  & > div {
    display: flex;
    flex-direction: column;
    line-height: 18px;
    align-items: center;
    span:nth-child(1) {
      font-size: 15px;
      font-weight: bold;
    }
    span:nth-child(2) {
      font-size: 12px;
    }
  }

  .anticon {
    // background: rgb(225, 155, 255);
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 50%;
    height: calc(100% + 10px);
    position: absolute;
    aspect-ratio: 1/1;
    left: -32px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: calc(100% - 4px);
      height: calc(100% - 4px);
    }
  }

  @media (max-width: ${LARGE_VIEWPORT}px) {
    right: 160px;
  }

  @media (max-width: ${SMALL_VIEWPORT}px) {
    width: calc(100% - 145px);
    right: 60px;
    bottom: 24px;
    height: auto;
    padding: 6px 8px;
    justify-content: center;
    .anticon {
      left: -25px;
    }
    & > div {
      line-height: 14px;
      text-align: center;
      span:nth-child(1) {
        font-size: 14px;
      }
      span:nth-child(2) {
        font-size: 11px;
      }
    }
  }

  @media (max-width: ${MOBILE_SMALL_VIEWPORT}px) {
    right: 20px;
    border-radius: 28px;
    width: calc(100% - 40px);
    .anticon {
      display: none;
    }
  }
`;

